import {
  AirHandlerTypeCodeType,
  HyperHeatFilterValueType,
  SystemTypeFilterValueType
} from 'data/types';
import { EquipmentFilterState } from 'features/ui/equipment-filter-types';

export type EquipmentFilterRequestProps = {
  airHandlerTypes: AirHandlerTypeCodeType[] | undefined;
  condenserSeries: string[] | undefined;
  condenserBtus: number[] | undefined;
  hyperHeat: HyperHeatFilterValueType[] | undefined;
  systemTypes: SystemTypeFilterValueType[] | undefined;
  refrigerants: string[] | undefined;
};

// Equipment-dimension fields of the valid-systems request bodies. On the
// ducted path the legacy DIY/Standard systemTypes dimension is inert (its
// accordion is hidden — AHA-6681 QA F6), so a persisted subset must not
// silently filter the list there: send undefined (all-enabled server-side)
// without mutating the persisted ui.equipmentFilters state. Flipping back
// to ductless restores the subset, and the request-hash change triggers the
// refetch each way.
export function equipmentFilterRequestProps(
  filters: EquipmentFilterState,
  isDucted: boolean
): EquipmentFilterRequestProps {
  return {
    airHandlerTypes: filters.airHandlerTypes ?? undefined,
    condenserSeries: filters.condenserSeries ?? undefined,
    condenserBtus: filters.condenserBtus ?? undefined,
    hyperHeat: filters.hyperHeat ?? undefined,
    systemTypes: isDucted ? undefined : filters.systemTypes ?? undefined,
    refrigerants: filters.refrigerants ?? undefined
  };
}
